// TODO: why is this a helper and not a method of tree manager?
export function updateBakedRuleValues(node, values, treeManager) {
    // Update .bakedRules, NOT preserving references of fields that haven't changed.
    // It's not worth the isEqual check, and we can rely on downstream selectors.
    const updatedBakedValues = {};
    for (const [name, value] of Object.entries(values)) {
        const key = name;
        updatedBakedValues[key] = value;
    }
    return treeManager.updatePcbLayoutNode(node.uid, (nodeDraft) => {
        nodeDraft.bakedRules = updatedBakedValues;
    });
}
//# sourceMappingURL=updateBakedRuleValues.js.map